const styles = {
  tableRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tableRowLeft: {
    display: 'inline-block'
  },
  tableRowRight: {
    textAlign: 'right',
    display: 'inline-block'
  }
}

export default styles;